import { STATES } from 'common/domain/states';
import Link from 'components/mainMenu/link';

class loansMenuService {

  getLinks() {
    let menuLabels = [
      'LOANS.CREDITWORTHINESS.TITLE',
      'LOANS.NEED_A_LOAN.TITLE',
      'LOANS.LOANS_CATALOG.TITLE',
      'LOANS.MY_LOANS.TITLE',
      'LOANS.WAGE_ADVANCE.TITLE',
    ];

    let menuTitles = menuLabels;

    let menuTargets = [
      STATES.LOANS.CREDITWORTHINESS,
      STATES.LOANS.NEED_A_LOAN,
      STATES.LOANS.LOANS_CATALOG,
      STATES.LOANS.MY_LOANS,
      STATES.LOANS.WAGE_ADVANCE,
    ];

    let hasSeparator = [
      false,
      false,
      false,
      false,
      true,
    ];

    let hasMenuBorder = [
      true,
      false,
      true,
      false,
      true,
    ];

    let altStates = [
      null,
      null,
      [STATES.LOANS.DETAIL],
      [STATES.LOANS.REPAYMENT],
      null,
    ];

    let fromStates = [
      null,
      [STATES.LOANS.NEED_A_LOAN_RESULTS],
      [STATES.LOANS.DETAIL, STATES.LOANS.SIGN_UP],
      [STATES.LOANS.CADASTRAL_REFERENCE],
      null,
    ];

    return menuLabels.map((label, index) => {
      let link = new Link(label, menuTitles[index], menuTargets[index]);

      if (hasSeparator[index]) {
        link.setSeparator();
      }

      if (!hasMenuBorder[index]) {
        link.setNoMenuBorder();
      }

      if (altStates[index]) {
        link.setAltStates(altStates[index]);
      }

      if (fromStates[index]) {
        link.setFromStates(fromStates[index]);
      }

      return link;
    });
  }
}

export default loansMenuService;



// WEBPACK FOOTER //
// ./client/app/loans.module/common/services/loans.menu.service.js